import { type ServiceMethod } from '@/application/interfaces/service';

import { type PendingSaleOrderData } from '../model';

export interface Response {
  data: PendingSaleOrderData[];
}

const getPendingSaleOrders: ServiceMethod<Response> =
  (httpClient) => async (options) => {
    const { body } = await httpClient.get<Response, undefined, undefined>(
      `/api/v3/sale-order/pending-payment-store-orders`,
      options
    );

    return body;
  };

export default getPendingSaleOrders;
